import { usePagesRedirect } from '@shared/hooks/use-pages-redirect.ts';

export const useProgramPageRedirect = () => {
  return usePagesRedirect('videoProgramPage');
};
